<script>
	import { getContext } from 'svelte'
	import { fade } from 'svelte/transition'
	// import InlineSVG from 'svelte-inline-svg'
	import { getLanguage, translate, formatFloat } from '../language'

	export let maptype = 'vector'
	export let imagePath = ''
	export let vectorPath = ''
	export let case_id
	export let case_data
	export let view = 'remote'
	export let width

	const t = translate
	const language = getLanguage()

	const isMobile = getContext('isMobile')

	export let imageWidth = 600
	export let imageHeightDesktop = 500
	export let imageHeightMobile = 600
	$: imageHeight = $isMobile ? imageHeightMobile : imageHeightDesktop

	$: fontFactor = $isMobile ? 33 : 44
	$: responsiveMode = $isMobile ? 'mobile' : 'desktop'
	/* previous fallback approach for text annotations */
	// const textSvgDesktop = `${basePath}/${case_id}-desktop-${view}-text.svg`
	// const textSvgMobile = `${basePath}/${case_id}-mobile-${view}-text.svg`
</script>

<figure
	class="map-container {view}"
	class:compact={$isMobile}
	style:--annotation-width="{$isMobile ? 18 : 20}ch"
	style:--chart-width="{width}px"
	style:--font-factor={fontFactor}
	style:--connectorLeft="{case_data.connector_line.left * 100}%"
	style:--connectorHeight="{((case_data.connector_line.height * width) / 6) *
		($isMobile ? 6 : 5)}px"
>
	<div class="image-layer">
		<img src={imagePath} alt="map of {case_id}" />
	</div>
	<div class="vector-layer" in:fade={{ delay: 150, duration: 400 }}>
		<img src={vectorPath} alt="vector map of {case_id}" />
	</div>
	<!-- <img
			src="{basePath}/{case_id}-{responsiveMode}-{view}-text.svg"
			alt="vector map of {case_id}"
			loading="lazy"
			decoding="async"
		/> -->
	<!-- {#if case_data.textStrings?.length > 0} -->
	<div class="annotation-layer {maptype}" in:fade={{ delay: 300, duration: 400 }}>
		<!-- previous fallback approach for text annotations -->
		<!-- {#if $isMobile}
				<InlineSVG src={textSvgMobile} focusable="false" width={null} height={null} />
			{:else}
				<InlineSVG src={textSvgDesktop} focusable="false" width={null} height={null} />
			{/if} -->
		<!-- HTML approach - TODO: mobile/desktop logic -->
		{#each case_data.textStrings[view] as annotation}
			{@const responsiveData = annotation[responsiveMode]}
			{@const top = (responsiveData.y / imageHeight) * 100}
			{@const left = (responsiveData.x / imageWidth) * 100}
			{@const anchorX =
				annotation.anchor_x === 'start' ? '0' : annotation.anchor_x === 'end' ? '-100%' : '-50%'}
			{@const anchorY =
				annotation.anchor_y === 'start' ? '0%' : annotation.anchor_y === 'end' ? '-100%' : '-50%'}
			{#if !($isMobile && annotation.hideOnMobile)}
				<!-- <div
					class="dot"
					style="top: {top}%; left: {left}%; width: 3px; height: 3px; background: blue; position: absolute; transform: translate(-50%, -50%); z-index: 100;"
				></div> -->
				<div
					class="annotation"
					class:placemark={annotation.is_placemark}
					class:landscape={annotation.is_landscape}
					class:prominent={annotation.is_prominent}
					class:italic={annotation.is_italic}
					style:--top="{top}%"
					style:--left="{left}%"
					style:--anchorX={anchorX}
					style:--anchorY={anchorY}
				>
					<p id={annotation.id}>
						{@html t(annotation.text)}
					</p>
				</div>
			{/if}
		{/each}
	</div>
	<!-- {/if} -->
</figure>

<style>
	/* figure.map-container.close::before {
		content: '';
		width: 2px;
		left: var(--connectorLeft);
		height: var(--connectorHeight);
		background: black;
		position: absolute;
		top: 0;
		transform: translateY(-100%);
	} */

	.map-container {
		position: relative;
		width: 100%;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		align-items: center;
		/*max-width: 620px;*/
		height: auto;

		& .image-layer {
			line-height: 0;
			width: 100%;
		}

		& img {
			width: 100%;
			height: auto;
		}

		& .vector-layer {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			pointer-events: none;
		}

		& .annotation-layer.aerial {
			--stroke-width: calc(var(--chart-width) / var(--font-factor, 400) / 14);
			--text-color: #fff;
			--shadow-color: #000;
			--blur: 1px;
		}

		& .annotation-layer.vector {
			--stroke-width: calc(var(--chart-width) / var(--font-factor, 400) / 10);
			--text-color: #000;
			--shadow-color: #fff;
			--blur: 0px;
		}

		& .annotation-layer {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			pointer-events: none;
			--text-shadow: calc(-1 * var(--stroke-width)) calc(-1 * var(--stroke-width)) var(--blur)
					var(--shadow-color),
				calc(1 * var(--stroke-width)) calc(-1 * var(--stroke-width)) var(--blur) var(--shadow-color),
				calc(-1 * var(--stroke-width)) calc(1 * var(--stroke-width)) var(--blur) var(--shadow-color),
				calc(1 * var(--stroke-width)) calc(1 * var(--stroke-width)) var(--blur) var(--shadow-color);

			& .annotation {
				font-size: calc(var(--chart-width) / var(--font-factor, 400));
				/* max-width: var(--annotation-width, 20ch); */
				line-height: 1.15;
				text-wrap: balance;
				position: absolute;
				top: var(--top);
				left: var(--left);
				/* outline: 1px solid red; */
				padding: 4px;
				transform: translate(var(--anchorX, 50%), var(--anchorY, 50%));
				/* transform: translate(var(--anchorX, 50%), var(--anchorY, 50%)); */
				color: var(--text-color);
				text-shadow: var(--text-shadow);

				& p {
					margin-top: 0;
					margin-bottom: 0;
					min-width: 14ch;
					max-width: var(--annotation-width, 20ch);
				}
			}

			& .annotation.italic p {
				font-style: italic;
			}

			& .annotation.placemark p {
				font-size: calc(var(--chart-width) / var(--font-factor, 400) * 0.85);
				text-transform: uppercase;
				color: var(--dark-grey);
				/* letter-spacing: 4px; */
			}

			& .annotation.prominent p {
				font-size: calc(var(--chart-width) / var(--font-factor, 400) * 1.35);
				text-transform: uppercase;
				letter-spacing: calc(var(--chart-width) / var(--font-factor, 400) / 4);
				font-weight: 400; /* TODO: should be Book ? */
				text-align: center;
				text-shadow: var(--text-shadow);
			}

			& .annotation.placemark.landscape p {
				font-size: calc(var(--chart-width) / var(--font-factor, 400) * 1.2);
				font-style: italic;
				color: #8f9ebf;
				text-shadow: none;
				text-transform: none;
			}
		}

		& .annotation-layer.aerial {
			/* TODO: TBC */
			& p {
				min-width: 10ch;
				max-width: 16ch;
			}

			& .annotation.placemark p {
				font-size: inherit;
				/* color: red; */
				text-transform: unset;
				font-weight: 500;
				/* letter-spacing: 4px; */
			}

			& .annotation.prominent p {
				font-size: inherit;
				color: orange;
				letter-spacing: normal;
				text-transform: capitalize;
			}

			& .annotation.placemark.prominent p {
				font-size: inherit;
				text-align: left;
			}

			& .annotation.placemark.landscape p {
				font-size: inherit;
				color: yellow;
			}
		}
	}
</style>
